module.exports = __webpack_public_path__ + "img/color_spotting_poster.a6c3852e.png";